<template>
    <div>
    </div>
</template>

<script>
    

    export default {
        name: "afterActivationRedirectPage",

        data() {
            return {

            }
        },

        created() {
            this.doRedirect();
        },

        methods: {
            doRedirect() {
                this.$router.push({
                    name: 'AfterActivation'
                })
            },
        },
    }
</script>

<style scoped>

</style>